const ActionCreator = (type, payload) => {
  return {type, payload};
};

export default ActionCreator;
